import * as TFF from '@tff/types/tff';

export type RefundDetailsByTicket = {
  ticketNumber: string;
  paxType: TFF.PaxType;
  fareAmount: number;
  taxAmount: number;
  ssrAmount: number;
};

export const getRefundForTicketNumber = (
  ticketNumber: string,
  flightDetails: TFF.FlightDetails,
  checkedRefundResponse: any,
  numberOfPaxType: { ADT: number; CHD: number; INF: number },
  bookingSource: string,
): RefundDetailsByTicket => {
  const fareForTicketNumber = Object.values(flightDetails.OrderDetails.Fares).find(
    f => f.TicketNumber === ticketNumber,
  );

  const defaultResult = {
    ticketNumber,
    paxType: (fareForTicketNumber?.PaxType ?? 'UNKNOWN') as TFF.PaxType,
    fareAmount: 0,
    taxAmount: 0,
    ssrAmount: 0,
  };

  if (!fareForTicketNumber) {
    return defaultResult;
  }

  const reshopOffer = checkedRefundResponse?.orderReshopResponse?.Response?.ReshopOffers?.Offer?.[0];
  if (!reshopOffer?.FeeDetails || reshopOffer.IsVoidable) {
    return defaultResult;
  }

  const feesForPax = reshopOffer.FeeDetails.find(
      (refundDetails: { PaxType: string; }) => refundDetails.PaxType === fareForTicketNumber.PaxType,
  );

  if (!feesForPax) {
    return defaultResult;
  }

  const divisor = bookingSource === 'TUI-NDC-EK' ? 1 : numberOfPaxType[fareForTicketNumber.PaxType];
  const penaltyAmount = feesForPax.PenaltyAmount?.Amount ?? 0;
  const originalAmount = feesForPax.OriginalOrderItemAmount.Amount ?? 0;
  const deductedAmount = feesForPax.DeductedOrderItemAmount.Amount ?? 0;
  const originalTax = feesForPax.OriginalOrderItemAmount.TaxSummary.TotalTaxAmount ?? 0;
  const deductedTax = feesForPax.DeductedOrderItemAmount.TaxSummary.TotalTaxAmount ?? 0;

  return {
    ticketNumber,
    paxType: fareForTicketNumber.PaxType,
    fareAmount: (originalAmount - deductedAmount - penaltyAmount) / divisor,
    taxAmount: (originalTax - deductedTax) / divisor,
    ssrAmount: 0,
  };
};
